module.exports = __webpack_public_path__ + "static/media/service1.025de6c9.png";